import ninjaApi from 'store/redux/apis/ninja.api';

export const campaignSpentApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['CampaignSpent'],
  endpoints: (build) => ({
    campaignSpentList: build.query({
      query: (body) => ({
        url: '/integration/campaign-spent/list',
        method: 'POST',
        body,
      }),
      providesTags: ['CampaignSpent'],
    }),

    campaignSpentSave: build.mutation({
      query: (body) => ({
        url: 'integration/campaign-spent/save',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CampaignSpent'],
    }),
  }),
});

export const { useCampaignSpentListQuery, useCampaignSpentSaveMutation } = campaignSpentApi;
